module.exports = __webpack_public_path__ + "static/media/icon10GB.4e3d917e.svg";